import PropTypes from "prop-types";
import React from "react";
import Icon from "../Icon";

import styles from "../../styles/createTest/AddAudience.css";

export default class AddAudienceCard extends React.PureComponent {
    static propTypes = {
        isLoading: PropTypes.bool.isRequired,
        isReadOnly: PropTypes.bool.isRequired,
        title: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired
    };

    render() {
        const enabled = !this.props.isLoading && !this.props.isReadOnly;
        const onClick = enabled ? this.props.onClick : null;

        return (
            <div className={styles.audienceCard}>
                <div className={styles.addAudience} onClick={onClick}>
                    <Icon
                        icon="plus-circle"
                        className={styles.addAudienceIcon}
                    />
                    <p className={styles.addAudienceLabel}>
                        Add {this.props.title}
                    </p>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CreateTest/AddAudienceCard.js